module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/elements/datepicker-8e13ec49354e6ce89e7385a1de757f34.svg";